import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'
// import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementRuLocale from 'element-ui/lib/locale/lang/ru-RU'// element-ui lang
import enLocale from './en'
import ruLocale from './ru'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  ru: {
    ...ruLocale,
    ...elementRuLocale
  }
}

let language = store.getters.getLanguage
let languages = store.getters.getLanguages
if (languages && languages.available) {
  if (!language || languages.available.indexOf(language) < 0) {
    language = languages.national
    store.dispatch('setLanguage', {lang: language})
  }
} else {
  language = process.env.DEFAULT_LANGUAGE
  store.dispatch('setLanguage', {lang: language})
}

localStorage.setItem('constantMessages', JSON.stringify(messages))

const i18n = new VueI18n({
  // set locale
  // options: en or zh
  locale: language,
  // set locale messages
  messages
})

i18n.applyTranslations = (translations) => {
  let translates = {}
  Object.keys(translations).forEach(function (keyLang) {
    let langTranslations = translations[keyLang]
    translates[keyLang] = {}
    Object.keys(langTranslations).forEach(sectionName => {
      Object.keys(langTranslations[sectionName]).forEach(sectionItemKey => {
        let key = sectionName + '.' + sectionItemKey
        translates[keyLang][key] = langTranslations[sectionName][sectionItemKey]
      })
    })
  })
  store.dispatch('setTranslates', {translates})
  let lang = store.getters.getLanguage
  let constantMessages = JSON.parse(localStorage.getItem('constantMessages')) || {}
  let localeMessage = Object.assign({}, constantMessages[lang], translates[lang])
  i18n.setLocaleMessage(lang, localeMessage)
}

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js